/**
 * AddContentAddonsCtrl controller
 */
import { CONTENT_TYPES_SETS, MONETIZATION_TYPES } from '../../../app/core/constants'
import moment from 'moment/moment'

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')
// controller mixins

/**
 * AddContentAddonsCtrl controller
 *
 * @class AddContentAddonsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AddContentAddonsCtrl
 */
/* @ngInject */
export default function AddContentAddonsCtrl ($uibModalInstance, authSvc, addedAddons, subscr, curScope) {
  const vm = this
  vm.FEATURE_RADIO_CHANNELS_ENABLED = authSvc.hasEnabledFlag('FEATURE_RADIO_CHANNELS_ENABLED')
  vm.isFormDisabled = true
  vm.added = { name: 'added', addons: addedAddons }
  vm.content_types_sets = CONTENT_TYPES_SETS
  vm.priceTypes = MONETIZATION_TYPES
  // vm.timeUnits = RENT_LENGTH_TYPES
  curScope.getContentAddons(subscr.id, curScope.subscription?.id)
    .then((res) => {
      const addons = res.contentAddons
        .filter(availableContentAddon => !vm.added.addons
          .filter(
            selectedContentAddon =>
              selectedContentAddon.id === availableContentAddon.id &&
          selectedContentAddon.contentType === availableContentAddon.contentType &&
          selectedContentAddon.priceType === availableContentAddon.priceType
          ).length)
      vm.available = { name: 'available', addons }
      vm.added.addons.forEach(addon => vm.disableDouble(addon, true))
    })

  vm.access = {
    channel: 'editChannel',
    tv_show: 'editVodSeries',
    live_event: 'editLiveEvent',
    vod: 'editVod'
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, event) {
    event.stopPropagation()
    list.addons = list.addons
      .slice(0, index)
      .concat(items)
      .concat(list.addons.slice(index))

    for (const item of items) {
      item.selected = !item.selected
      vm.disableDouble(item, list.name === 'added')
    }

    vm.isFormDisabled = false
    return true
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.addons = list.addons.filter(item => !item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => { item.selected = false })
    list.dragging = false
  }

  vm.onSelected = function (list, addon) {
    if (addon.disabled || addon.purchaseType) { return }
    addon.selected = !addon.selected
    vm.disableDouble(addon)
  }

  /**
   * Delete content addon from Added Content Add-ons
   *
   * @memberof mwApp/packages.controller:AddContentAddonsCtrl
   */
  vm.deleteContentAddonFromAdded = function (index) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    const deletedAddon = vm.added.addons.splice(index, 1)[0]
    deletedAddon.selected = false
    vm.disableDouble(deletedAddon)
    vm.available.addons.push(deletedAddon)
    vm.isFormDisabled = false
  }

  vm.disableDouble = function (addon, disabled) {
    const double = vm.available.addons.find(item => item.id === addon.id && item.priceType !== addon.priceType && item.contentType === addon.contentType)
    if (double) {
      double.disabled = disabled || addon.selected
    }
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  vm.assign = function () {
    $uibModalInstance.close({ added: vm.added.addons, available: vm.available.addons })
  }

  vm.showLength = function (addon) {
    if (addon.periodUnlimited) {
      return '∞'
    } else if (addon.dueDate) {
      return 'to: ' + moment(addon.dueDate).format('DD.MM.YYYY')
    } else {
      return addon.period && addon.timeUnit ? addon.period + ' ' + addon.timeUnit[0] : ' — '
    }
  }
}
